import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQS = [
  {
    q: "Do I need to know anything technical to order a chatbot?",
    a: "Nothing. You give me your FAQs, services, and any docs you want the bot to know — I do the rest. You'll get a copy-paste embed code you (or your web person) can drop into your site in two minutes. I include a written walkthrough for the major platforms (WordPress, Wix, Squarespace, Shopify) so installation is foolproof.",
  },
  {
    q: "How long does a chatbot project take?",
    a: "Most projects are delivered in 3–7 business days depending on tier. Rush delivery (48 hours) is available for an additional fee.",
  },
  {
    q: "Can the chatbot integrate with my booking system, CRM, or email?",
    a: "Yes — in the Premium tier. Standard tier includes email lead notifications. Premium adds calendar booking (Calendly/Google Calendar), CRM lead-push (HubSpot, GoHighLevel, etc.), and a private dashboard to view conversations.",
  },
  {
    q: "How is a Melavate chatbot different from just adding ChatGPT to my site?",
    a: "ChatGPT doesn't know your business. Your hours, your services, your pricing, your tone. A Melavate chatbot is trained on your actual content so every conversation feels like an extension of you — not a generic AI. It also captures leads, books appointments, and ties into your workflow. That's the difference between a toy and a tool.",
  },
  {
    q: "Will my data and customers' conversations be kept private?",
    a: "Absolutely. Every Melavate engagement is covered by a confidentiality agreement. Your business data, your customers' conversations, your documents — all stay between us. Always.",
  },
  {
    q: "How do revisions work?",
    a: "Every Melavate project includes 2 rounds of revisions, requested within 14 days of delivery. After that window the project is considered closed. Additional rounds are $25 each, or you can opt into a monthly maintenance retainer ($75/mo+) for ongoing tweaks.",
  },
  {
    q: "What about changes months later?",
    a: "Once a project is delivered and the 14-day revision window closes, that scope is complete. If you need updates later — content refreshes, retraining on new info, adding features — that's a new project (or a low-cost monthly retainer). This keeps things fair for both of us.",
  },
  {
    q: "What if I'm not sure which tier I need?",
    a: "Reach out and tell me what you're trying to accomplish. I'll tell you honestly which tier fits — or whether a custom scope makes more sense. No-pressure conversation, free of charge.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section data-testid="faq-section" className="bg-cream section-pad">
      <div className="container-edit">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="eyebrow mb-5">Questions</div>
            <h2 className="h-section text-plum-deepest mb-6">
              Asked & <span className="font-display-italic text-gold-deep">answered.</span>
            </h2>
            <p className="text-muted-plum leading-relaxed">
              Don't see your question here? Reach out below — I respond personally to every
              message within 24 hours.
            </p>
          </div>

          <div className="lg:col-span-8">
            <div className="border-t border-plum/10">
              {FAQS.map((item, i) => {
                const open = openIndex === i;
                return (
                  <div
                    key={i}
                    data-testid={`faq-item-${i}`}
                    className="border-b border-plum/10"
                  >
                    <button
                      onClick={() => setOpenIndex(open ? -1 : i)}
                      className="w-full flex items-start justify-between gap-6 text-left py-6 group"
                      data-testid={`faq-toggle-${i}`}
                    >
                      <span className="font-display text-lg md:text-xl text-plum-deepest group-hover:text-plum transition-colors">
                        {item.q}
                      </span>
                      <span className="text-plum mt-1 flex-shrink-0">
                        {open ? <Minus size={20} /> : <Plus size={20} />}
                      </span>
                    </button>
                    {open && (
                      <div className="pb-7 pr-10 text-muted-plum leading-relaxed">
                        {item.a}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
